/**
 * core/blob-shadow.js
 * Quản lý bóng tròn mờ (Blob Shadow) và chính sách bóng đổ Studio (Shadow Policy)
 */

import * as THREE from 'three';

/**
 * Tạo bóng hình tròn đơn giản (dành cho động vật hoặc vật thể nhỏ)
 * @param {object} options
 * @param {number} [options.radius=0.35]
 * @param {number} [options.opacity=0.35]
 * @returns {{ mesh: THREE.Mesh, geometry: THREE.BufferGeometry, material: THREE.Material }}
 */
export function createSimpleBlobShadow(options = {}) {
  const radius = options.radius || 0.35;
  const opacity = options.opacity !== undefined ? options.opacity : 0.35;
  const shadowGeo = new THREE.CircleGeometry(radius, 24);
  shadowGeo.rotateX(-Math.PI / 2);

  const shadowMat = new THREE.MeshBasicMaterial({
    color: 0x000000,
    transparent: true,
    opacity: opacity,
    depthWrite: false
  });

  const shadowMesh = new THREE.Mesh(shadowGeo, shadowMat);
  shadowMesh.name = 'BlobShadow';
  shadowMesh.position.y = 0.005;

  return { mesh: shadowMesh, geometry: shadowGeo, material: shadowMat };
}

/**
 * Thực thi chính sách bóng đổ Studio:
 * - Đặt castShadow = false cho các mesh con nhân vật (tránh tự đổ bóng gắt/lỗi hiển thị theo hợp đồng test)
 * - Bật receiveShadow = true để đón ánh sáng dịu
 * - BlobShadow: castShadow = false, receiveShadow = false
 * - Tuỳ chọn giới hạn metalness <= 0.35 cho nhân vật Voxel
 * @param {THREE.Object3D} root
 * @param {object} [options]
 * @param {THREE.Mesh} [options.blobShadow]
 * @param {boolean} [options.capMetalness=false]
 */
export function enforceShadowPolicy(root, options = {}) {
  const { blobShadow, capMetalness = false } = options;
  if (!root) return;

  root.traverse((child) => {
    if (child.isMesh) {
      if (child.name === 'BlobShadow' || child === blobShadow) {
        child.castShadow = false;
        child.receiveShadow = false;
      } else {
        child.castShadow = false;
        child.receiveShadow = true;
      }

      if (capMetalness) {
        const mats = Array.isArray(child.material) ? child.material : [child.material];
        mats.forEach((m) => {
          if (m && m.metalness > 0.35) {
            m.metalness = 0.35;
            m.roughness = Math.max(m.roughness, 0.3);
          }
        });
      }
    }
  });
}
